export const nav = {
    permissao: "lpbuilder.versoes:editar",
    section: "LPBuilder",
    title: "ComponentesEditaveis",
    icon: "tune",
    route: "/componentes-editaveis",
    sequence: 4,
};
export default [
    {
        path: "/componentes-editaveis",
        name: "lpbuilder-componentes",
        component: () => import("./pages/ComponentesPage.vue"),
        meta: { requiresAuth: true, permissao: "lpbuilder.versoes:editar" },
    },
];
